import ConstantPredictionRuleModel from "./ConstantPredictionRuleModel.js";
import FromActualsPredictionRuleModel from "./FromActualsPredictionRuleModel.js";
import LinearRegressionPredictionRuleModel from "./LinearRegressionPredictionRuleModel.js";
import ModelFactory from "../../../ModelFactory.js";
import SeasonalTrendPredictionRuleModel from "./SeasonalTrendPredictionRuleModel.js";
import SingularSpectrumAnalysisRuleModel from "./SingularSpectrumAnalysisRuleModel.js";

/**
 * Factory class to instantiate an {@link AbstractPredictionRuleModel}
 * according to its type.
 */
class PredictionRuleModelFactory extends ModelFactory {
	allClasses() {
		return [ConstantPredictionRuleModel, ...this.groupRowClasses()];
	}

	groupRowClasses() {
		return [
			LinearRegressionPredictionRuleModel,
			FromActualsPredictionRuleModel,
			SeasonalTrendPredictionRuleModel,
			SingularSpectrumAnalysisRuleModel,
		];
	}

	makeDefault() {
		return new ConstantPredictionRuleModel();
	}
}

export default new PredictionRuleModelFactory();
